import React, { useState, useEffect } from 'react';
import * as request from 'superagent';
import { makeStyles, Theme, createStyles } from '@mui/styles';
import { SummaryCard } from '~common/components/query-fulfillment/query-results-summary-card';
import { Typography, Card, CardHeader, CardContent, CardActionArea } from '@mui/material';
import LoadingView from '~common/components/loading-view';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap'
    },
    card: {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
    unselected: {
      flexGrow: 1,
      border: "1px solid #ffffff"
    },
    cardContent: {
      paddingTop: 5,
      paddingBottom: "5px !important",
      textAlign: "center"
    },
    // These are to override the default styles for the summary card
    summaryArea: {
      position: "relative",
      minHeight: "150px",
      flex: 1,
    },
    summaryTableArea: {
      paddingTop: 0,
      overflow: "scroll",
    },
    facetTitle: {
      fontSize: "1.3em",
      fontWeight: 510,
      marginBottom: theme.spacing(1),
    },
    facetValue: {
      top: "40px",
      fontSize: "1.6em",
      fontWeight: 550,
    },    
  }),
);

interface QueryResultsSummaryAreaProps {
  // This should be summary data as documented in `docs/confluence/features/executive-spend-report.adoc`
  summaries: any | undefined;
}

export const QueryResultsSummaryArea: React.FC<QueryResultsSummaryAreaProps> = ({ summaries, classes }) => {
  // This allows us to override the default styles by passing in a classes object
  var classesLocal = useStyles();
  if(classes) {
    classesLocal = Object.assign({}, classesLocal, classes);
  }
  classes = classesLocal;


  var cards = summaries.reduce((acc, summary, idx) => {
    var wrapperClass = classes.unselected;
    var cardClasses = {
      summaryArea: classes.summaryArea,
      facetTitle: classes.facetTitle,
      facetValue: classes.facetValue
    }

    if (summary.label && summary.facets) {
      if (!summary.key) {
        summary.key = "summary-card-" + idx;
      }
      acc.push(<div key={summary.key} className={wrapperClass}><SummaryCard classes={cardClasses} data={summary} /></div>)
    }
    return acc;
  }, []);

  var wrapperClass = classes.unselected;
  return (
    <div className={classes.container}>
      {cards}
    </div>
  );
};
